/**
 * @generated SignedSource<<69fe015398b608800fb3332cb5836fc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type USWorkField_User$data = {
  readonly profile: {
    readonly canWorkInTheUs: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "USWorkField_User";
};
export type USWorkField_User$key = {
  readonly " $data"?: USWorkField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"USWorkField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "USWorkField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canWorkInTheUs",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e1436808497c3d38d69ab1d1df51df9c";

export default node;
